import { render, staticRenderFns } from "./ReturnSettingsDetails.vue?vue&type=template&id=1369c2d8"
import script from "./ReturnSettingsDetails.vue?vue&type=script&lang=js"
export * from "./ReturnSettingsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports